import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {gsap} from "gsap";
import {LonerSSDMainView} from "../../../view/features/shootshootduck/LonerSSDMainView";

/**
 * Created by Jerker Nord on 2022-11-10.
 */

export class LonerShootShootDuckIntroPresentation implements SimplePresentation {

    public shouldRun(): boolean {
        return (Loner.model.data.mode == LonerGameMode.NORMAL
            && Loner.model.data.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK)
            || (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK && Loner.model.isRestore == true)
    }

    public start(controller: SimplePresentationRunnerController): void {
        //Delay for music on restore
        if (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK && Loner.model.isRestore == true){
            gsap.timeline({delay:LonerSSDMainView.DUCK_START_DELAY, onComplete:()=>controller.finish()});
        }else{
            Loner.ssdIntroView.showFSIntro(() => LonerShootShootDuckIntroPresentation.fsIntroClosedCallback(controller));
        }
    }

    private static fsIntroClosedCallback(controller: SimplePresentationRunnerController): void {
        //Delay for music
        gsap.timeline({delay: LonerSSDMainView.DUCK_START_DELAY}).add(() => {
            controller.finish();
        });
    }
}